import { ENUM_TIPO_PESSOA } from 'utils/consts';
import { getAssuntoUrl } from 'utils/funcaoPadrao';
import { valueOrDefaultValue } from 'utils/formUtils';
import { formatarPessoaFisicaFrontToBack, formatarPessoaJuridicaFrontToBack } from './pessoa';
import { convertDatePtBr } from 'utils/dateFormatter';

export const formatterRequerimentoBackToFront = dadosApi => {
  const tipoPessoa =
    dadosApi?.formularioPessoa?.tipoPessoaId === ENUM_TIPO_PESSOA.fisica.id
      ? ENUM_TIPO_PESSOA.fisica
      : ENUM_TIPO_PESSOA.juridica;
  const pessoa = dadosApi?.formularioPessoa?.pessoa;
  return {
    id: dadosApi?.id,
    localizador: dadosApi.localizador,
    status: dadosApi.status,
    servico: dadosApi.assunto.descricao,
    sexo: pessoa?.sexo?.descricao,
    escolaridade: pessoa?.escolaridade?.descricao,
    profissao: pessoa?.profissao?.descricao,
    tipoPessoa: tipoPessoa.descricao,
    nome: pessoa?.nome,
    nomeSocial: pessoa?.nomeSocial,
    cpf: pessoa?.cpf,
    dataNascimento: convertDatePtBr(pessoa?.dataNascimento),
    email: pessoa?.email,
    telefone: pessoa?.telefone,
    pais: pessoa?.endereco.pais,
    cep: pessoa?.endereco.cep,
    logradouro: pessoa?.endereco.logradouro,
    complemento: pessoa?.endereco.complemento,
    numero: pessoa?.endereco.numero,
    bairro: pessoa?.endereco.bairro,
    cidade: pessoa?.endereco.cidade,
    estado: pessoa?.endereco.estado,
    cargoRepresentante: pessoa?.cargoRepresentante,
    razaoSocial: pessoa?.razaoSocial,
    cnpj: pessoa?.cnpj,
    inscricaoEstadual: pessoa?.inscricaoEstadual,
    inscricaoMunicipal: pessoa?.inscricaoMunicipal,
    instituicao: pessoa?.instituicao?.nomeInstituicao,
    areaAtuacao: pessoa?.areaAtuacao?.atuacao,
    arquivos: dadosApi.arquivos,
    solicitacao: dadosApi?.solicitacao,
    formularioJustificativa: dadosApi?.formularioJustificativas,
    setorId: dadosApi?.setorId,
    ultimoAtendenteQueEncaminhou: dadosApi?.ultimoAtendenteQueEncaminhou,
    setorOrigem: dadosApi?.setorOrigem,
    setorDestino: dadosApi?.setorDestino,
  };
};

const removerMascaraInputs = dadosInputs => {
  const { tipoPessoa, servico, captchaId, userEnteredCaptchaCode, justificativa } = dadosInputs;

  const tipoPessoaFormatada =
    ENUM_TIPO_PESSOA.fisica.descricao === tipoPessoa ? ENUM_TIPO_PESSOA.fisica : ENUM_TIPO_PESSOA.juridica;

  return {
    ...dadosInputs,
    tipoPessoaId: tipoPessoaFormatada.id,
    servico: !servico ? null : parseInt(servico, 10),
    captchaId: captchaId,
    userEnteredCaptchaCode: userEnteredCaptchaCode,
    justificativa: justificativa || null,
  };
};

export const formatterRequerimentoFrontToBack = dadosFormulario => {
  const dadosFormatados = removerMascaraInputs(dadosFormulario);
  const dadosRequest = {
    id: 0,
    assuntoId: dadosFormulario?.assuntoId || getAssuntoUrl(),
    solicitacaoId: dadosFormatados?.servico,
    formularioJustificativa: {
      justificativa: dadosFormatados.justificativa,
      formularioId: 0,
      atendenteId: null,
      isAtendente: false,
    },
    formularioPessoa: {
      pessoaId: 0,
      tipoPessoaId: dadosFormatados?.tipoPessoaId,
      formularioId: 0,
      pessoa: null,
    },
    captcha: {
      captchaId: dadosFormatados?.captchaId,
      userEnteredCaptchaCode: dadosFormatados?.userEnteredCaptchaCode,
    },
  };

  if (dadosFormatados?.tipoPessoa.id === ENUM_TIPO_PESSOA.fisica.id) {
    dadosRequest.formularioPessoa.pessoa = formatarPessoaFisicaFrontToBack(dadosFormatados, true);
  } else dadosRequest.formularioPessoa.pessoa = formatarPessoaJuridicaFrontToBack(dadosFormatados, true);

  return dadosRequest;
};

export const formatterRequerimentoNull = (defaultValue = {}, observacaoUrl = null) => {
  return {
    tipoPessoa: ENUM_TIPO_PESSOA.fisica.descricao,
    // PESSOA GLOBAL
    nome: valueOrDefaultValue(defaultValue?.nome, null),
    nomeSocial: valueOrDefaultValue(defaultValue?.nomeSocial, null),
    cpf: valueOrDefaultValue(defaultValue?.cpf, null),
    dataNascimento: defaultValue?.dataNascimento || null,
    sexoId: valueOrDefaultValue(defaultValue?.sexoId, ''),
    email: valueOrDefaultValue(defaultValue?.email, null),
    telefone: valueOrDefaultValue(defaultValue?.telefone, null),
    escolaridadeId: valueOrDefaultValue(defaultValue?.escolaridadeId, ''),
    profissaoId: valueOrDefaultValue(defaultValue?.profissaoId, ''),
    pais: valueOrDefaultValue(defaultValue?.pais, null),
    cep: valueOrDefaultValue(defaultValue?.cep, null),
    logradouro: valueOrDefaultValue(defaultValue?.logradouro, null),
    complemento: valueOrDefaultValue(defaultValue?.complemento, null),
    numero: valueOrDefaultValue(defaultValue?.numero, null),
    bairro: valueOrDefaultValue(defaultValue?.bairro, null),
    cidade: valueOrDefaultValue(defaultValue?.cidade, null),
    estado: valueOrDefaultValue(defaultValue?.estado, null),
    // PESSOA JURIDICA
    cargoRepresentante: valueOrDefaultValue(defaultValue?.cargoRepresentante, null),
    razaoSocial: valueOrDefaultValue(defaultValue?.razaoSocial, null),
    cnpj: valueOrDefaultValue(defaultValue?.cnpj, null),
    inscricaoEstadual: valueOrDefaultValue(defaultValue?.inscricaoEstadual, null),
    inscricaoMunicipal: valueOrDefaultValue(defaultValue?.inscricaoMunicipal, null),
    instituicaoId: valueOrDefaultValue(defaultValue?.instituicaoId, ''),
    areaAtuacaoId: valueOrDefaultValue(defaultValue?.areaAtuacaoId, ''),
    servico: valueOrDefaultValue(defaultValue?.servico, null),
    justificativa: valueOrDefaultValue(defaultValue?.justificativa, observacaoUrl),
  };
};
